export const AUTH_USER = "AUTH_USER";
export const USER_DETAILS = "USER_DETAILS";
export const SEARCH_TEXT = "SEARCH_TEXT";